import { render } from "./CreateCameraModal.vue?vue&type=template&id=3516f4c3"
import script from "./CreateCameraModal.vue?vue&type=script&lang=js"
export * from "./CreateCameraModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__